module.exports = (__webpack_require__(7))(527);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/platform-browser/node_modules/tslib/tslib.es6.js from dll-reference vendor
// module id = 1236
// module chunks = 0